module.exports = __webpack_public_path__ + "img/service-zhinengfanqizha2.a900bb0d.svg";